import moment from 'moment';
import { getMetricsMapping } from '../utils';

export const getTableColumns = () => [
  {
    title: '#',
    key: 'index',
    width: 50,
    cellRenderer: ({ rowIndex }) => rowIndex + 1,
  },
  {
    title: 'CDN',
    dataKey: 'resource',
    key: 'resource',
    sortable: true,
    resizable: true,
    width: 200,
  },
  {
    title: 'ASN',
    dataKey: 'asnname',
    key: 'asnname',
    sortable: true,
    resizable: true,
    width: 200,
  },
  {
    title: 'Policy',
    dataKey: 'policy',
    key: 'policy',
    sortable: true,
    resizable: true,
    width: 300,
  },
  {
    title: 'Start Time',
    dataKey: 'starttime',
    key: 'starttime',
    sortable: true,
    resizable: true,
    width: 200,
  },
  {
    title: 'Duration (min)',
    dataKey: 'totaltime',
    key: 'totaltime',
    sortable: true,
    resizable: true,
    align: 'center',
    width: 125,
  },
  {
    title: 'Trigger KPI',
    dataKey: 'triggerkpi',
    key: 'triggerkpi',
    sortable: true,
    resizable: true,
    width: 150,
    cellRenderer: ({ cellData }) => {
      const metricMapping = getMetricsMapping();
      return metricMapping[cellData];
    },
  },
  {
    title: 'Blacklisted KPI',
    dataKey: 'blacklistedkpi',
    key: 'blacklistedkpi',
    sortable: true,
    resizable: true,
    width: 125,
  },
  {
    title: 'Reference KPI',
    dataKey: 'referencekpi',
    key: 'referencekpi',
    sortable: true,
    resizable: true,
    width: 125,
  },
  {
    title: 'KPI Sample Size',
    dataKey: 'kpisamplesize',
    key: 'kpisamplesize',
    sortable: true,
    resizable: true,
    width: 150,
  },
];

const formatNumber = (number) => {
  return Math.round(number * 100) / 100;
};

export const formatTableData = (data) => {
  return data.slice(0, 100).map((item) => {
    return {
      resource: item.resource,
      asn: item.asn,
      asnname: `${item.asn} -  ${item.asnname}`,
      dma: item.dma,
      dmaname: item.dmaname,
      policy: item.policy,
      starttime: moment(item.starttime, 'YYYY-MM-DD HH:mm:ss.SSS').format('YYYY-MM-DD HH:mm:ss'),
      triggerkpi: item.triggerkpi,
      totaltime: item.totaltime,
      blacklistedkpi: formatNumber(item.blacklistedkpi),
      referencekpi: formatNumber(item.referencekpi),
      kpisamplesize: item.kpisamplesize,
    };
  });
};
